// src/components/LastUpdatedIndicator.jsx
import React from 'react';

const LastUpdatedIndicator = ({ lastUpdated, isLoading }) => {
  // Calculate how long ago the data was updated
  const getTimeAgo = (date) => {
    if (!date) return 'Never';
    
    const now = new Date();
    const updated = new Date(date);
    const seconds = Math.floor((now - updated) / 1000);
    
    if (seconds < 5) return 'Just now';
    if (seconds < 60) return `${seconds} seconds ago`;
    
    const minutes = Math.floor(seconds / 60);
    if (minutes === 1) return '1 minute ago';
    if (minutes < 60) return `${minutes} minutes ago`;
    
    const hours = Math.floor(minutes / 60);
    if (hours === 1) return '1 hour ago';
    return `${hours} hours ago`;
  };

  // Format the date for tooltip
  const formatDateTime = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleString();
  };

  return (
    <div className="flex items-center text-xs text-gray-500 mt-2">
      <div className={`w-2 h-2 rounded-full mr-2 ${
        isLoading 
          ? 'bg-yellow-400 animate-pulse' 
          : lastUpdated 
            ? 'bg-green-500' 
            : 'bg-red-500'
      }`} />
      
      <span title={formatDateTime(lastUpdated)}>
        {isLoading 
          ? 'Updating prices...' 
          : `Prices updated: ${getTimeAgo(lastUpdated)}`
        }
      </span>
      
      {!isLoading && lastUpdated && (
        <span className="ml-1 text-gray-400">
          (auto-refreshes every 30s)
        </span>
      )}
    </div>
  );
};

export default LastUpdatedIndicator;